import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import TitleFlow from '../titleFlow/';
import BigTitle from '../../../components/bigTitByMoreOrAll/';
import ImgAndTextFlow from '../imgAndTextFlow/';

class DynamicAndPlatform extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const titleArr = content.dynamic || [];
        const platformArr = content.platform || [];

        return (
            <div className={styles.dynamicAndPlatformArea}>
                <div className={styles.dynamicArea}>
                    <Chip
                        id="50122"
                        type="struct"
                        title="研究院动态banner"
                        groupName="财经研究院首页"
                        content={content.dyBanner}>
                        <BigTitle />
                    </Chip>
                    <ul className={styles.dynamicList}>
                        <TitleFlow content={content.dyInfo} />
                    </ul>
                </div>
                <div className={styles.platformArea}>
                    <Chip
                        id="50123"
                        type="struct"
                        title="凤凰平台banner"
                        groupName="财经研究院首页"
                        content={content.platBanner}>
                        <BigTitle />
                    </Chip>
                    <ul className={styles.dynamicList}>
                        <Chip
                            id="75154"
                            type="recommend"
                            title="凤凰平台"
                            groupName="财经研究院首页"
                            content={content.paltInfo}>
                            <ImgAndTextFlow />
                        </Chip>
                    </ul>
                </div>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
DynamicAndPlatform.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
DynamicAndPlatform.defaultProps = {};

export default DynamicAndPlatform;
